/* eslint-disable */

import request from '@/utils/request'
import qs from 'qs'
export function getListForecast(query) {
  return request({
    url: '/report-service/v1/forecast-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
